import styled from 'styled-components'
import { FlexWithMargins } from './FlexWithMargins'

export const FlexCol = styled(FlexWithMargins)`
  flex-direction: column;
`
